var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('website-header',{attrs:{"card-back":_vm.cardBack}}),_c('data-reliable-index',[_c('data-rel-content')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }